/**
 * Custom error for SoloStar extension.
 */
export class SSError extends Error {
  constructor(message: string) {
    super(`SS: ${message}`);
  }
}
